import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import * as icons from '../themes/icons';
const StyledSvg = styled.svg `
  path {
    /**
     * Applying the same approach as for path:first-of-type (see below) does not
     * work here as this would paint white/transparent <path> elements, too.
     */
    fill: ${props => props.fillAll};
  }

  path:first-of-type {
    fill: ${props => props.fill === '' && props.fillAll === '' ? 'currentColor' : props.fill};
  }
`;
/**
 * Icon component which uses a slot where the icon definition can be
 * passed into. This allows icons to be treeshaken.
 */
const Icon = ({ className = undefined, dataTestId = undefined, dataTestIdTitle = undefined, fill = '', fillAll = '', height = 42, title = undefined, type = 'toniesLogo', width = 42, shouldBeHiddenFromSR = undefined, 'data-testid': testId = 'icon', }) => {
    const { t } = useTranslation('Icon');
    const icon = typeof type === 'string' ? icons[type] : type;
    return (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg" // TODO: remove this; unnecessary for inline SVG, but potentially a breaking change (snapshots)
        , className: className, "data-testid": dataTestId || testId || 'icon', viewBox: icon.viewBox, width: width, height: height, fill: fill, fillAll: fillAll, "aria-hidden": shouldBeHiddenFromSR },
        title !== null && (React.createElement("title", { "data-testid": dataTestIdTitle || `${testId}-title` || 'icon-title' }, title ? title : t(`Icon:${icon.name}`))),
        type &&
            Array.isArray(icon.paths) &&
            icon.paths.map(p => React.createElement("path", Object.assign({ d: p.path, key: p.path }, p.attributes)))));
};
export default Icon;
